import State from "@/helpers/pattern/state";
import { ParametrosModel } from "@/models/generales/parametros";
import { modelIsModified } from "@/helpers/vue-mc";
import ParametrosAPI from "@/services/generales/parametros";
import { scrollToForm } from "@/helpers/form-scroll-to";
import { EventBus } from "@/events/event-bus";
import * as events from "@/constants/event-names";

/**
 * State Pattern for Tema form
 */
export default class ParametrosStates extends State {
  /**
   * Class constructor, important pass the required data within the states methods
   * @param {*} data Any type of data that you want available within the states methods
   */

  constructor(data) {
    super(data);
  }

  /**
   * General Methods
   */
  base() {
    return {
      resetModel({ $data }) {
        $data.parametros = new ParametrosModel();
      }
      , resetValidators({ $data }) {
        $data.$v.$reset();
      }
      , isDisableButtonSubmit({ $data }) {
        return $data.hasErrors($data.$v.parametros) || $data.view.action.submit.busy || !modelIsModified($data.parametros);
      }
    };
  }

  /**
   * States and its methods
   */
  states() {
    return {
      initial: {
        $constructor: function () {
          // Reset Models and validators
          this.resetModel();
          this.resetValidators();
        }
      }
      , editing: {
        $constructor: function (
          { $data },
          {
            clave,
            enableSFTPU,
            urlBuzonSFTPU,
            usuarioBuzonSFTPU,
            passwordBuzonSFTPU,
            puertoBuzonSFTPU,
            directorioSFTPU,
            enableSFTPD,
            urlBuzonSFTPD,
            usuarioBuzonSFTPD,
            passwordBuzonSFTPD,
            puertoBuzonSFTPD,
            directorioSFTPD,
            enableZIP,
            passwordZIP,
            enableMail,
            enableMailBases,
            numeroIntentos,
            maxFileSize,
            maxFileSizeZip,
            geoPais,
            geoPaisCompleto,
            geoRelevanciaBuena,
            geoRelevanciaRegular,
            geoRelevanciaMala,
            geocodeMapbox,
            geocodeGoogle,
            geocodeGoogleRelMala,
            geocodeGoogleRelRegular,
            geocodeGoogleRelBuena,
            geocodeGoogleImportarBases,
            version
          }
        ) {
          $data.parametros = new ParametrosModel({
            clave
            , enableSFTPU
            , urlBuzonSFTPU
            , usuarioBuzonSFTPU
            , passwordBuzonSFTPU
            , puertoBuzonSFTPU
            , directorioSFTPU
            , enableSFTPD
            , urlBuzonSFTPD
            , usuarioBuzonSFTPD
            , passwordBuzonSFTPD
            , puertoBuzonSFTPD
            , directorioSFTPD
            , enableZIP
            , passwordZIP
            , enableMail
            , enableMailBases
            , numeroIntentos
            , maxFileSize
            , maxFileSizeZip
            , geoPais
            , geoPaisCompleto
            , geoRelevanciaBuena
            , geoRelevanciaRegular
            , geoRelevanciaMala
            , geocodeMapbox
            , geocodeGoogle
            , geocodeGoogleRelMala
            , geocodeGoogleRelRegular
            , geocodeGoogleRelBuena
            , geocodeGoogleImportarBases
            , version
          });

          this.resetValidators();
        }
        , async submit(
          { $data },
          {
            clave,
            enableSFTPU,
            urlBuzonSFTPU,
            usuarioBuzonSFTPU,
            passwordBuzonSFTPU,
            puertoBuzonSFTPU,
            directorioSFTPU,
            enableSFTPD,
            urlBuzonSFTPD,
            usuarioBuzonSFTPD,
            passwordBuzonSFTPD,
            puertoBuzonSFTPD,
            directorioSFTPD,
            enableZIP,
            passwordZIP,
            enableMail,
            enableMailBases,
            numeroIntentos,
            maxFileSize,
            maxFileSizeZip,
            geoPais,
            geoPaisCompleto,
            geoRelevanciaBuena,
            geoRelevanciaRegular,
            geoRelevanciaMala,
            geocodeMapbox,
            geocodeGoogle,
            geocodeGoogleRelMala,
            geocodeGoogleRelRegular,
            geocodeGoogleRelBuena,
            geocodeGoogleImportarBases,
            version
          }
        ) {
          try {
            if (!$data.isAllValid($data.$v)) {
              EventBus.$emit(events.SHOW_TOASTER_MESSAGE, "error", "VL0000", $data.$t("errors.validof"));
              scrollToForm($data);
              return false;
            }

            $data.view.action.submit.busy = true;

            const response = await ParametrosAPI.update({
              clave
              , enableSFTPU
              , urlBuzonSFTPU
              , usuarioBuzonSFTPU
              , passwordBuzonSFTPU
              , puertoBuzonSFTPU
              , directorioSFTPU
              , enableSFTPD
              , urlBuzonSFTPD
              , usuarioBuzonSFTPD
              , passwordBuzonSFTPD
              , puertoBuzonSFTPD
              , directorioSFTPD
              , enableZIP
              , passwordZIP: enableZIP ? passwordZIP : null
              , enableMail
              , enableMailBases
              , numeroIntentos
              , maxFileSize
              , maxFileSizeZip
              , geoPais
              , geoPaisCompleto
              , geoRelevanciaBuena
              , geoRelevanciaRegular
              , geoRelevanciaMala
              , geocodeMapbox
              , geocodeGoogle
              , geocodeGoogleRelMala
              , geocodeGoogleRelRegular
              , geocodeGoogleRelBuena
              , geocodeGoogleImportarBases
              , version
            });

            $data.view.action.submit.busy = false;
            return response;
          } catch (error) {
            console.log(error);
            $data.view.action.submit.busy = false;
            return error;
          }
        }
      }
    };
  }
}



// WEBPACK FOOTER //
// ./src/views/generales/parametros/parametros-state.js